export default __webpack_public_path__ + "static/media/dashboard-faq.6c13f227.svg";